import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=19a25658"
import script from "./rewards.ts?vue&type=script&lang=ts&external"
export * from "./rewards.ts?vue&type=script&lang=ts&external"
import style0 from "./rewards.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports